<form [formGroup]="newSureparkGroupForm" autocomplete="off">
    <div class="grid p-fluid mt-5">
        <div class="field col-6">
            <label for="name" class="label-required w-full">Name</label>
            <input pInputText id="name" formControlName="name" />
            <div *ngIf="newSureparkGroupFormSubmitted && newSureparkGroupForm.controls['name'].errors">
                <div class="ui-messages-error" *ngIf="newSureparkGroupForm.controls['name'].errors?.['required']">Please
                    enter group name.
                </div>
            </div>
        </div>
        <div class="field col-6">
            <label for="cardFunction" class="label-required w-full">Card Function</label>
            <p-dropdown id="cardFunction" formControlName="cardFunction" [options]="cardFunctionOptions"
                optionLabel="name" optionValue="code" appendTo="body" class="w-full">
            </p-dropdown>
            <div *ngIf="newSureparkGroupFormSubmitted && newSureparkGroupForm.controls['cardFunction'].errors">
                <div class="ui-messages-error"
                    *ngIf="newSureparkGroupForm.controls['cardFunction'].errors?.['required']">Please
                    select a card function.
                </div>
            </div>
        </div>
        <div class="field col-6">
            <label for="antiPassback" class="label-required w-full">Anti-Passback <i
                    class="pi pi-question-circle text-primary cursor-pointer" [pTooltip]="antiPassHelpText"
                    [escape]="false" tooltipPosition="right"></i>
            </label>
            <p-dropdown id="antiPassback" formControlName="antiPassback" [options]="antiPassbackOptions"
                optionLabel="name" optionValue="code" appendTo="body" class="w-full">
            </p-dropdown>
            <div *ngIf="newSureparkGroupFormSubmitted && newSureparkGroupForm.controls['antiPassback'].errors">
                <div class="ui-messages-error"
                    *ngIf="newSureparkGroupForm.controls['antiPassback'].errors?.['required']">Please
                    select anti-passback.
                </div>
            </div>
        </div>
        <div class="field col-6">
            <label for="stations" class="w-full">Stations</label>
            <p-multiSelect id="stations" formControlName="stations" [options]="lotIdOptions" optionLabel="name"
                optionValue="id" appendTo="body" class="w-full" [showClear]="true">
            </p-multiSelect>
        </div>
        <div class="field col-6">
            <label for="schedules" class="w-full">Schedules</label>
            <p-multiSelect id="schedules" formControlName="schedules" [options]="timezoneGroupOptions"
                optionLabel="name" optionValue="id" appendTo="body" class="w-full" [showClear]="true">
            </p-multiSelect>
        </div>
    </div>
</form>